export const API_URL =
  window.location.hostname === "localhost" ? "http://localhost:5001" : "";

export const GOOGLE_CLIENT_ID =
  "489082440714-ano87b90sgm6i9bu11u5tp3tkm2vjja0.apps.googleusercontent.com";
